'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	PARENTS: {
		TITLE: 'What parents are saying',
		DESCRIPTION:
			'See how kids are taking their favourite games to the next level with the power of code'
	},
	EDUCATORS: {
		TITLE: 'What our camp partners say',
		DESCRIPTION: 'See how camp leaders have found using Code Kingdoms'
	},
	SCHOOLS: {
		TITLE: 'What our educator partners say',
		DESCRIPTION: 'See how teachers have found using Code Kingdoms'
	}
});
